import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/stat-contact-customer'

export async function statByDate(params) {
    const query = stringify(params)
    return request(`${api.statByDate.url}${query ? `?${query}` : ''}`)
}

export async function exportStatByDate(params) {
    const query = stringify(params)
    return request(`${api.exportStatByDate.url}${query ? `?${query}` : ''}`, null, {
        returnResponse: true,
    })
}
